import {FileInfo, SurveyId} from 'common/models/survey';

import {sdk} from './sdk';

const uploadFile = (surveyId: SurveyId, file: File): Promise<FileInfo> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('surveyId', String(surveyId));
    return sdk.form.uploadFile(formData);
};
export default uploadFile;
